import { func, object, string } from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { actions as applicationActions } from '../../features/Application';
import {
  ApartmentCard,
  FlexWrapper,
  InfoText,
  ListBox,
  StartButton,
  SwapPreview,
  WelcomeSection,
} from '../styles';

function Home({ application: { applicants }, name, startApplicant }) {
  function renderImages() {
    applicants.map(applicant => {
      window.debug.log(
        applicant.image,
        applicant.apartments.apartment1.address
      );
      return (
        <ApartmentCard key={Math.random()} url={applicant.image}>
          <span>{applicant.apartments.apartment1.address}</span>
        </ApartmentCard>
      );
    });
  }

  return (
    <FlexWrapper mobileColumn>
      <WelcomeSection>
        <h1>
          Hej där, {name}! <br /> Välkommen till Bytesansökan.
        </h1>

        <p>
          Vi är glada att du har hittat ett byte och ser fram emot att hjälpa
          dig hela vägen till ditt nya boende.
        </p>
        <p style={{ width: '100%' }}>
          Läs igenom våra villkor{' '}
          <a
            href="https://www.lagenhetsbyte.se/allmanna-villkor"
            target="_blank"
            rel="noopener noreferrer">
            här
          </a>.
        </p>

        <ListBox>
          <h3>Följ de här enkla stegen:</h3>

          <ol>
            <li>
              <div>
                <span>1</span>
              </div>
              <p>
                <strong>Information om dig och din lägenhet</strong>
                <br />
                Fyll i detaljer om dig och din lägenhet som krävs av din
                hyresvärd.
              </p>
            </li>
            <li>
              <div>
                <span>2</span>
              </div>
              <p>
                <strong>Ladda upp dokument</strong>
                <br />
                Skicka in personbevis, hyresavtal och andra dokument som behövs
                i bytesprocessen.
              </p>
            </li>
            <li>
              <div>
                <span>3</span>
              </div>
              <p>
                <strong>Signera bytesansökan</strong>
                <br />
                Skriv under med hjälp av BankID för att färdigställa ansökan.
              </p>
            </li>
          </ol>
        </ListBox>

        <FlexWrapper mobileColumn>
          <StartButton big primary onClick={startApplicant}>
            Starta Bytesansökan
          </StartButton>
          <InfoText>
            Genom att klicka på Starta Bytesansökan bekräftar du att alla parter
            är med på att genomföra bytet.
          </InfoText>
        </FlexWrapper>
      </WelcomeSection>
      <SwapPreview>{renderImages()}</SwapPreview>
    </FlexWrapper>
  );
}

const mapStateToProps = state => ({
  name: state.application.currentApplicant.members.member1.name,
  application: state.application.application,
});

const mapDispatchToProps = dispatch => ({
  startApplicant: () => dispatch(applicationActions.startApplicant()),
});

Home.propTypes = {
  application: object.isRequired, // eslint-disable-line react/forbid-prop-types
  name: string.isRequired,
  startApplicant: func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(Home);



// WEBPACK FOOTER //
// ./src/views/Home/index.js